import { render } from "./MultiSelect.vue?vue&type=template&id=7d8ddb88&ts=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__